import state from './informacastm2m.state'
import mutations from './informacastm2m.mutations'
import actions from './informacastm2m.actions'

export default {
  state,
  mutations,
  actions
}
